// Centralized business data for Il Velocipede
export const BUSINESS = {
  name: "Il Velocipede",
  tagline: "Rivenditore Ufficiale Piaggio e Kymco a Roma dal 1973",
  foundedYear: 1973,
  address: "Piazza dell'Ateneo Salesiano, 79",
  city: "00139 Roma",
  district: "Nuovo Salario - Roma Nord",
  phoneDisplay: "+39 392 189 3121",
  phoneRaw: "+393921893121",
  whatsappDisplay: "+39 392 189 3121",
  whatsappRaw: "393921893121",
  email: "info@ilvelocipede.it",
  mapsEmbed:
    "https://www.google.com/maps?q=Piazza%20dell'Ateneo%20Salesiano%2C%2079%2C%2000139%20Roma&output=embed",
  mapsLink:
    "https://www.google.com/maps/place/Piazza+dell'Ateneo+Salesiano,+79,+00139+Roma+RM",
  hours: [
    { d: "Lunedì", h: "09:00 – 13:00 · 15:30 – 19:30" },
    { d: "Martedì", h: "09:00 – 13:00 · 15:30 – 19:30" },
    { d: "Mercoledì", h: "09:00 – 13:00 · 15:30 – 19:30" },
    { d: "Giovedì", h: "09:00 – 13:00 · 15:30 – 19:30" },
    { d: "Venerdì", h: "09:00 – 13:00 · 15:30 – 19:30" },
    { d: "Sabato", h: "09:00 – 13:00" },
    { d: "Domenica", h: "Chiuso" },
  ],
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_scooter-salario/artifacts/1wwupzc7_Progetto%20senza%20titolo%20%2827%29.png",
  logoDark: "https://customer-assets.emergentagent.com/job_19b8b2fa-b54a-441c-a292-cd209d028bd1/artifacts/ut1v891l_Progetto%20senza%20titolo%20%2826%29.png",
  piaggio:
    "https://customer-assets.emergentagent.com/job_19b8b2fa-b54a-441c-a292-cd209d028bd1/artifacts/bri5egi7_1.png",
  kymco:
    "https://customer-assets.emergentagent.com/job_19b8b2fa-b54a-441c-a292-cd209d028bd1/artifacts/zbygzred_2.png",
  storefront:
    "https://customer-assets.emergentagent.com/job_19b8b2fa-b54a-441c-a292-cd209d028bd1/artifacts/88xccv95_ChatGPT%20Image%205%20giu%202026%2C%2016_27_59.png",
  workshopScooter:
    "https://images.unsplash.com/photo-1628645712740-3633d3566d4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  workshopBike:
    "https://images.pexels.com/photos/31714310/pexels-photo-31714310.jpeg?auto=compress&cs=tinysrgb&w=1600",
  urbanRome:
    "https://images.unsplash.com/photo-1613241811774-f75736a131bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const USP = [
  { title: "Attivi dal 1973", desc: "Oltre 52 anni di esperienza nel mondo delle due ruote a Roma Nord.", icon: "Award" },
  { title: "Rivenditore Ufficiale Piaggio", desc: "Vendita, assistenza e ricambi originali della casa di Pontedera.", icon: "BadgeCheck" },
  { title: "Rivenditore Ufficiale Kymco", desc: "Tutta la gamma Kymco con assistenza tecnica autorizzata.", icon: "BadgeCheck" },
  { title: "Officina Specializzata", desc: "Meccanici qualificati per moto, scooter e biciclette.", icon: "Wrench" },
  { title: "Assistenza Rapida", desc: "Interventi veloci con preventivi chiari e trasparenti.", icon: "Clock" },
  { title: "Ricambi Originali", desc: "Solo componenti certificati dalle case madri.", icon: "PackageCheck" },
  { title: "Riferimento Roma Nord", desc: "Punto di fiducia per Nuovo Salario, Montesacro e quartieri limitrofi.", icon: "MapPin" },
];

export const MOTO_SERVICES = [
  "Tagliandi periodici",
  "Manutenzione ordinaria",
  "Manutenzione straordinaria",
  "Diagnosi elettronica",
  "Riparazioni meccaniche",
  "Riparazioni motore",
  "Riparazioni trasmissione",
  "Cambio olio e filtri",
  "Sostituzione pneumatici",
  "Sostituzione batterie",
  "Revisione freni",
  "Controllo sospensioni",
  "Riparazione impianti elettrici",
  "Installazione accessori",
  "Assistenza scooter Piaggio",
  "Assistenza scooter Kymco",
  "Ricambi originali",
  "Preparazione revisione ministeriale",
];

export const BIKE_SERVICES = [
  "Riparazione biciclette",
  "Cambio camere d'aria",
  "Sostituzione copertoni",
  "Regolazione freni",
  "Regolazione cambio",
  "Revisione completa",
  "Manutenzione biciclette elettriche",
  "Assemblaggio biciclette",
  "Controlli di sicurezza",
];

export const GOOGLE_REVIEWS_URL = "https://www.google.com/search?q=il+velocipede+roma+recensioni#lrd=0x0:0x0,1";
export const GOOGLE_WRITE_REVIEW_URL = "https://search.google.com/local/writereview?placeid=ChIJ_il_velocipede";
export const GOOGLE_MAPS_REVIEWS_URL = "https://share.google/4jmwAsMfyRZCmHtUI";

export const GOOGLE_RATING = {
  score: 4.4,
  scoreDisplay: "4,4",
  totalLabel: "Recensioni Google",
};

export const REVIEWS = [
  {
    name: "Monica Tulli",
    role: "5 recensioni · 1 foto",
    text:
      "Solo per caso ho visto il negozio e l'officina. Conosciuti per un tagliando occasionale, sono rimasta loro cliente. Hanno mostrato attenzione alle mie esigenze, devo dire, a volte esagerate. Mi sono fidata dei consigli e sono rimasta soddisfatta. Onesti, puntuali, capaci. Superconsigliato.",
    rating: 5,
    initial: "M",
  },
  {
    name: "Giammaria Noviello",
    role: "Local Guide · 52 recensioni · 23 foto",
    text:
      "Perfetto! Sono rimasto a piedi con lo scooter e il centro assistenza Piaggio mi ha indicato questa officina AUTORIZZATA! Nonostante mi sia presentato senza appuntamento, sono stato accolto subito dal gentilissimo Luca che, dopo avermi tranquillizzato, si è subito messo all'opera. Hanno risolto un problema collegato alla centralina e, vista la loro disponibilità ed efficienza, ho chiesto anche di fare un tagliando. Prezzi onesti e modici, ma la gentilezza e la professionalità dimostrate non hanno prezzo. Grazie ancora.",
    rating: 5,
    initial: "G",
  },
  {
    name: "Pier Francesco",
    role: "4 recensioni",
    text:
      "Con molta cortesia e serietà, hanno risolto un problema che avevo inutilmente segnalato ad altre due officine autorizzate Piaggio. Con pazienza, hanno verificato il problema e si sono attivati per fare arrivare i ricambi necessari. Il tutto in garanzia. Sarà la mia unica officina/concessionaria di riferimento.",
    rating: 5,
    initial: "P",
  },
  {
    name: "Agnese Borghini",
    role: "Local Guide · 9 recensioni",
    text:
      "Il signor Marco è una persona squisita, ho acquistato da lui due bici di seconda mano ad un ottimo prezzo per i miei bambini. Non solo me le ha consegnate perfettamente revisionate, ma mi ha offerto anche assistenza gratuita dopo che i bambini inesperti avevano danneggiato un freno rompendolo con vari urti. Una gentilezza d'altri tempi, lo consiglio certamente.",
    rating: 5,
    initial: "A",
  },
];

export const FAQS = [
  {
    q: "Dove si trova Il Velocipede?",
    a: "Il Velocipede si trova in Piazza dell'Ateneo Salesiano, 79 - 00139 Roma, nel quartiere Nuovo Salario (Roma Nord), facilmente raggiungibile da Montesacro, Talenti, Conca d'Oro e Fidene.",
  },
  {
    q: "Siete rivenditore ufficiale Piaggio?",
    a: "Sì, Il Velocipede è rivenditore ufficiale Piaggio a Roma dal 1973. Vendiamo l'intera gamma Piaggio e Vespa con assistenza tecnica autorizzata e ricambi originali.",
  },
  {
    q: "Siete rivenditore ufficiale Kymco?",
    a: "Sì, siamo rivenditore ufficiale Kymco per Roma Nord. Disponibili tutti i modelli a listino con assistenza specializzata e ricambi originali Kymco.",
  },
  {
    q: "Effettuate tagliandi scooter?",
    a: "Certamente. La nostra officina specializzata effettua tagliandi periodici su scooter di qualsiasi marca, con particolare specializzazione su Piaggio e Kymco. Utilizziamo solo ricambi e oli originali.",
  },
  {
    q: "Riparate biciclette?",
    a: "Sì, disponiamo di un reparto dedicato all'officina biciclette: riparazioni, manutenzione, sostituzione componenti e assistenza completa per biciclette muscolari ed elettriche (e-bike).",
  },
  {
    q: "È possibile prenotare un intervento via WhatsApp?",
    a: "Assolutamente sì. Puoi scriverci su WhatsApp al +39 392 189 3121 per descrivere il problema, ricevere un preventivo indicativo e fissare un appuntamento in officina.",
  },
  {
    q: "Fornite ricambi originali?",
    a: "Sì, utilizziamo esclusivamente ricambi originali Piaggio, Kymco e dei migliori brand del settore, per garantire affidabilità e durata nel tempo del tuo veicolo.",
  },
];

export const PIAGGIO_HIGHLIGHTS = [
  "Vespa - icona italiana, eleganza e tradizione",
  "Liberty - praticità urbana e bassi consumi",
  "Beverly - comfort e sicurezza per la città",
  "Medley - tecnologia e maneggevolezza",
  "MP3 - il tre ruote che cambia il modo di guidare",
];

export const KYMCO_HIGHLIGHTS = [
  "Agility - affidabilità e prezzo competitivo",
  "People - ergonomia e ruote alte",
  "Downtown - granturismo urbano",
  "AK 550 - performance da maxi-scooter",
  "Like - design retrò moderno",
];
